import React from 'react';

export const ptsdAssignmentDescription = (
  <h3 className="vads-u-font-size--h5">Your assignment</h3>
);
export const ptsdAssignmentDatesTitle = (
  <h3 className="vads-u-font-size--h5">When were you assigned to this unit?</h3>
);
export const ptsdAssignmentDatesDescription = (
  <p>(If you don’t know the exact date you can give us an estimate.)</p>
);
